import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initObservability } from '@zetyar/obs-web'
import { ErrorBoundary } from '@zetyar/obs-web/react'
import './index.css'
import App from './App.tsx'

// Aviso a la central cuando algo revienta en el navegador.
//
// Sin llave el paquete queda dormido y la aplicación funciona igual; si la
// central no contesta, tampoco pasa nada aquí. Vigilar no puede tumbar la
// aplicación.
//
// Lo que NO sale de aquí: nada de lo que escriben los vecinos. El paquete tacha
// correos, teléfonos y RUT del texto del error antes de enviarlo, y nunca manda
// la pila de llamadas ni el cuerpo de las peticiones.
initObservability({
  key: import.meta.env.VITE_OBS_KEY,
  environment: 'production',
  release: __RELEASE__,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Un fallo de la interfaz deja de ser una pantalla en blanco, y queda avisado. */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
